import React, { useState } from 'react';
import api from '../BaseURL/BaseURL';
import { useAuth } from '../../Components/Contexts/AuthContext';
import menu from '../../assets/Images/menu.png';
import addWhite from '../../assets/Images/addWhite.png';
import addBlack from '../../assets/Images/addBlack.png';
import homeWhite from '../../assets/Images/homeWhite.png';
import homeBlack from '../../assets/Images/homeBlack.png';
import tableWhite from '../../assets/Images/tableWhite.png';
import tableBlack from '../../assets/Images/tableBlack.png';
import logoutBlack from '../../assets/Images/logoutBlack.png';
import logoutWhite from '../../assets/Images/logoutWhite.png';
import foodBlack from '../../assets/Images/food black.png';
import foodWhite from '../../assets/Images/food white.png';
import foodTypeBlack from '../../assets/Images/food type black.png';
import foodTypeWhite from '../../assets/Images/food type white.png';
import sourceBlack from '../../assets/Images/sourceBlack.png';
import sourceWhite from '../../assets/Images/sourceWhite.png';
import reasonBlack from '../../assets/Images/reasonBlack.png';
import reasonWhite from '../../assets/Images/reasonWhite.png';

function Sidebar({ activeLink, setActiveLink, isSupervisorDashboard, isEmployeeDashboard }) {
  const [isOpen, setIsOpen] = useState(false); 
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isAddItemOpen, setIsAddItemOpen] = useState(false); 
  const { setToken, token  } = useAuth(); 

  const links = [
    {
      name: 'الرئيسية',
      key: 'Home',
      iconActive: homeWhite, // White icon
      iconInactive: homeBlack, // Black icon
    },
    {
      name: 'إضافة عنصر',
      key: 'Add-item',
      iconActive: addWhite, // White icon
      iconInactive: addBlack, // Black icon
    },
    {
      name: 'جدول البيانات',
      key: 'Table',
      iconActive: tableWhite, // White icon
      iconInactive: tableBlack, // Black icon
    },
  ];

  if (isEmployeeDashboard) {
    links.splice(2, 0, {
      name: 'إضافة عنصر مؤقت',
      key: 'Add-Item-Temporary',
      iconActive: addWhite, 
      iconInactive: addBlack, 
    });
  }

const handleLogout = async () => {
  try {
    const isInstitution = localStorage.getItem('institutionDetails') !== null;
    const endpoint = isInstitution ? '/institution/logout' : '/employee/logout';

    // console.log('Token being sent:', token); // Debugging: Ensure the token is being passed

    const response = await api.post(endpoint, {}, {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`, // Use the token from context
      },
    });

    if (response.status === 200 && response.data.status) {
      console.log(response.data.message);

      // ✅ Keep 'items' in local storage and remove everything else
      const storedItems = localStorage.getItem('items'); // Save stored items
      localStorage.clear(); // Clear local storage
      if (storedItems) {
        localStorage.setItem('items', storedItems); // Restore items
      }

      setToken(null); // Clear the token in AuthContext
      window.location.href = './'; // Redirect to login page
    }
  } catch (error) {
    console.error('Logout failed:', error);
    if (error.response && error.response.status === 401) {
      alert('Session has expired. Please log in again.');

      // ✅ Keep 'items' and clear everything else
      const storedItems = localStorage.getItem('items');
      localStorage.clear();
      if (storedItems) {
        localStorage.setItem('items', storedItems);
      }

      setToken(null); // Clear the token in AuthContext
      window.location.href = './'; // Redirect to login page
    } else {
      alert('Failed to log out. Please try again.');
    }
  }
};

  
  const confirmLogout = () => {
    setShowLogoutModal(true); // Show the confirmation modal
  };

  const closeLogoutModal = () => {
    setShowLogoutModal(false); // Hide the confirmation modal
  };

  return (
    <div>
      {/* Menu Icon (Visible only on mobile and tablet) */}
      <button
        className="fixed top-4 right-4 z-50 lg:hidden"
        onClick={() => setIsOpen(!isOpen)}
      >
        <img src={menu} alt="Menu" className="w-8 h-8" />
      </button>

      {/* Sidebar */}
      <div
        className={`bg-gray-100 w-64 p-4 h-screen fixed top-0 right-0 shadow-lg transform z-40 ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        } transition-transform duration-300 lg:translate-x-0`}
      >
        <h2 className="text-xl font-bold text-right mr-4 text-gray-700 mb-8 mt-8">القائمة</h2>
        <nav className="space-y-8">
          {links.map((link) => (
            <div key={link.key}>
              <button
                onClick={() => {
                  setActiveLink(link.key);
                  setIsAddItemOpen(link.key === 'Add-item' ? !isAddItemOpen : false); // Toggle dropdown for Add-item
                  setIsOpen(false); // Close the sidebar on link click
                }}
                className={`w-full text-right py-2 px-4 rounded-lg ${
                  activeLink === link.key
                    ? 'bg-[#DD5B35] text-white'
                    : 'text-gray-700 hover:bg-[#FFE6E0]'
                }`}
              >
                <div className="flex items-center justify-between">
                  {/* Left Side - Arrow Icon */}
                  <svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 24 24"
  strokeWidth="1.5"
  stroke={activeLink === link.key ? 'white' : 'gray'}
  className={`w-5 h-5 transform transition-transform duration-300 ${
    isSupervisorDashboard && isAddItemOpen && link.key === "Add-item"
                ? "-rotate-90"
                : ""
  }`}
>
  <path strokeLinecap="round" strokeLinejoin="round" d="M15 5l-7 7 7 7" />
</svg>


                  {/* Right Side - Icon and Text */}
                  <div className="flex items-center space-x-3 rtl:space-x-reverse">
                    <span className="text-lg font-medium">{link.name}</span>
                    <img
                      src={
                        activeLink === link.key ? link.iconActive : link.iconInactive
                      }
                      alt={link.name}
                      className="w-5 h-5"
                    />
                  </div>
                </div>
              </button>

              {/* Sub-options for Add-item */}
              {isSupervisorDashboard && isAddItemOpen && link.key === 'Add-item' && (
  <ul className="mt-2">
    <li
      className={`px-4 py-2 cursor-pointer mr-2 justify-between rounded-lg ${
        activeLink === 'Add-meal'
        ? 'bg-[#DD5B35] text-white'
        : 'text-gray-700 hover:bg-[#FFE6E0]'
      }`}
      onClick={() => setActiveLink('Add-meal')}
    >
      <div className="flex items-center justify-between">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={activeLink === 'Add-meal' ? 'white' : 'gray'}
          className="w-4 h-4"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 5l-7 7 7 7" />
        </svg>
        <div className="flex items-center space-x-3 rtl:space-x-reverse">
          <span className="text-md font-medium">إضافة وجبة</span>
          <img
        src={activeLink === 'Add-meal' ? foodWhite : foodBlack}
        alt="إضافة وجبة"
        className="w-5 h-5"
      />
        </div>
      </div>
    </li>

    <li
      className={`px-4 py-2 cursor-pointer mr-2 justify-between rounded-lg ${
        activeLink === 'Add-food-type'
        ? 'bg-[#DD5B35] text-white'
        : 'text-gray-700 hover:bg-[#FFE6E0]'
      }`}
      onClick={() => setActiveLink('Add-food-type')}
    >
      <div className="flex items-center justify-between">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={activeLink === 'Add-food-type' ? 'white' : 'gray'}
          className="w-5 h-5"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 5l-7 7 7 7" />
        </svg>
        <div className="flex items-center space-x-3 rtl:space-x-reverse">
          <span className="text-md font-medium">إضافة نوع الغذاء</span>
          <img
            src={activeLink === 'Add-food-type' ? foodTypeWhite : foodTypeBlack}
            alt="إضافة نوع الغذاء"
            className="w-4 h-4"
          />
        </div>
      </div>
    </li>

    <li
      className={`px-4 py-2 cursor-pointer mr-2 justify-between rounded-lg ${
        activeLink === 'Add-source'
        ? 'bg-[#DD5B35] text-white'
        : 'text-gray-700 hover:bg-[#FFE6E0]'
      }`}
      onClick={() => setActiveLink('Add-source')}
    >
      <div className="flex items-center justify-between">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={activeLink === 'Add-source' ? 'white' : 'gray'}
          className="w-5 h-5"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 5l-7 7 7 7" />
        </svg>
        <div className="flex items-center space-x-3 rtl:space-x-reverse">
          <span className="text-md font-medium">إضافة المصدر</span>
          <img
            src={activeLink === 'Add-source' ? sourceWhite : sourceBlack}
            alt="إضافة المصدر"
            className="w-4 h-4"
          />
        </div>
      </div>
    </li>

    <li
      className={`px-4 py-2 cursor-pointer mr-2 justify-between rounded-lg ${
        activeLink === 'Add-reason'
        ? 'bg-[#DD5B35] text-white'
        : 'text-gray-700 hover:bg-[#FFE6E0]'
      }`}
      onClick={() => setActiveLink('Add-reason')}
    >
      <div className="flex items-center justify-between">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={activeLink === 'Add-reason' ? 'white' : 'gray'}
          className="w-5 h-5"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 5l-7 7 7 7" />
        </svg>
        <div className="flex items-center space-x-3 rtl:space-x-reverse">
          <span className="text-md font-medium">إضافة السبب</span>
          <img
            src={activeLink === 'Add-reason' ? reasonWhite : reasonBlack}
            alt="إضافة السبب"
            className="w-5 h-5"
          />
        </div>
      </div>
    </li>

    <li
      className={`px-4 py-2 cursor-pointer mr-2 justify-between rounded-lg ${
        activeLink === 'TableTemporary'
        ? 'bg-[#DD5B35] text-white'
        : 'text-gray-700 hover:bg-[#FFE6E0]'
      }`}
      onClick={() => setActiveLink('TableTemporary')}
    >
      <div className="flex items-center justify-between">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={activeLink === 'TableTemporary' ? 'white' : 'gray'}
          className="w-5 h-5"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 5l-7 7 7 7" />
        </svg>
        <div className="flex items-center space-x-3 rtl:space-x-reverse">
        <span className="text-xs font-medium">مؤقت</span>
          <span className="text-md font-medium">جدول البيانات</span>
          
          <img
            src={activeLink === 'TableTemporary' ? tableWhite : tableBlack}
            alt="إضافة السبب"
            className="w-5 h-5"
          />
        </div>
      </div>
    </li>
  </ul>
)}

            </div>
          ))}
        </nav>

        {/* Logout Button */}
        <div className="absolute bottom-24 w-[87%]">
          <button
             onClick={confirmLogout} 
            className="w-full text-right py-2 px-4 rounded-lg  text-black hover:bg-[#FFE6E0] transition flex items-center justify-between"
          >
            {/* Left Side - Arrow Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="black"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 5l-7 7 7 7"
              />
            </svg>

            {/* Right Side - Icon and Text */}
            <div className="flex items-center space-x-3 rtl:space-x-reverse">
              <span className="text-lg font-medium">تسجيل الخروج</span>
              <img
                src={activeLink === 'logout' ? logoutBlack : logoutBlack}
                alt="تسجيل الخروج"
                className="w-5 h-5"
              />
            </div>
          </button>
        </div>
      </div>

      {showLogoutModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md">
            <h2 className="text-xl font-bold mb-4 text-center">تأكيد تسجيل الخروج</h2>
            <p className="text-center text-gray-700 mb-6">هل أنت متأكد أنك تريد تسجيل الخروج؟</p>
            <div className="flex justify-center space-x-4 rtl:space-x-reverse">
              <button
                onClick={handleLogout}
                className="bg-red-500 text-white py-2 px-4 rounded-lg hover:bg-red-600"
              >
                نعم، تسجيل الخروج
              </button>
              <button
                onClick={closeLogoutModal}
                className="bg-gray-300 text-black py-2 px-4 rounded-lg hover:bg-gray-400"
              >
                إلغاء
              </button>
            </div>
          </div>
        </div>
      )}
      
    </div>
  );
}

export default Sidebar;
